<template>
    <b-badge v-if="statusInfo" :variant="statusInfo.variant">
        {{ statusInfo.text }}
    </b-badge>
    <span v-else>-</span>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    components: {
        BBadge,
    },
    props: {
        row: Object,
        field: [Number, String],
    },
    data() {
        return {
            statusMap: {
                0: { text: "Onay Bekliyor", variant: "light-warning" },
                1: { text: "Onaylandı", variant: "light-success" },
                2: { text: "Reddedildi", variant: "light-danger" },
            },
        };
    },
    computed: {
        statusInfo() {
            return this.field != null ? this.statusMap[this.field] : null;
        },
    },
};
</script>
